var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDebugButton)?_c('button',{staticClass:"button is-small debug-button",attrs:{"title":"Debug in SnapQL Debugger"},on:{"click":_vm.openExplorer}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"mdi mdi-code-tags"})])
}]

export { render, staticRenderFns }